export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='w-full py-6 px-4 text-center text-sm text-muted-foreground border-t border-border bg-background'>
      <p>Desarrollado por Microsyst © {currentYear}</p>
    </footer>
  );
};
